/* eslint-disable camelcase */
/* eslint-disable no-prototype-builtins */
/* eslint-disable promise/always-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable indent */
import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import { List, Divider, IconButton, Hidden, useMediaQuery, useTheme } from '@material-ui/core'
import { Route, Link, Redirect, Switch, withRouter, useHistory, useParams } from 'react-router-dom'
import moment from 'moment'
import { BillNotPaidModal, Drawer, DrawerListItem, DrawerNestedListItem, VerifyEmailCardDrawer, PrimaryButton, StepperModal } from '../../Components'
import {
  DashboardIcon,
  LogoutIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  logoIcon,
  logoName,
  HelpIcon
} from '../../Themes/Images'
import ChatBubbleIcon from '@material-ui/icons/ChatBubble'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded'
import { colors } from '../../Themes'
import { useAuth, useMenu, useSubscription } from '../../Global'
import { useWindowDimensions } from '../../Utils'
import Settings from '../Settings/Settings'
import Dashboard from '../Dashboard/Dashboard'
import Tooltips from '../Tooltips/Tooltips'
import NotFound from '../NotFound/NotFound'
import UpgradeSubscription from '../UpgradeSubscription/UpgradeSubscription'
import UpgradePlan from '../UpgradePlan/UpgradePlan'
import GigaAccountEndedModal from '../../Components/GigaAccountEndedModal/GigaAccountEndedModal'
import TrialDaysCard from '../../Components/TrialDaysCard/TrialDaysCard'
import CostumerFeedbackInput from '../../Components/CustomerFeedbackInput/CostumerFeedbackInput'
import CostumerModalFeedback from '../../Components/CostumerModalFeedback/CostumerModalFeedback'
import Store from '../Addons/Store'
import StoreProductDetails from '../Addons/StoreProductDetails'
import { useStyles } from './Wrapper.styles'
import { Auth } from 'aws-amplify'
import ReferalCard from '../../Components/ReferalCard'
import InactiveToActiveModal from '../../Components/InactiveToActiveModal'
import XERODashboard from '../XERODashboard'
import DeletePlan from '../DeletePlan'
import { DrawerNestedListItemDashboards } from '../../Components/Drawer/Drawer'
import MultipleDashboard from '../MultipleDashboards'
import AIAssistant from '../AI-Assistant'
import ConfirmSignupModal from './ConfirmSignUp'
import { aiAssistantItem, dashboardItem, DRAWER_FILES, DRAWER_ITEMS, DRAWER_ITEMS_MOBILE, DRAWER_OTHER_ITEMS, DRAWER_OTHER_ITEMS2, DRAWER_UPLOAD_FILE, xeroDashboardItems } from './utils/data'


function MiniDrawer() {
  const classes = useStyles()
  const history = useHistory()
  const { dashboard_id } = useParams()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(760))
  const {
    logout,
    userAttributes,
    website_locked,
    end_of_trial_date,
    is_trialing,
    showFreeTrialModal,
    data_loading,
    active_dash,
    account_state,
    plan2,
    subscription_id,
    xeroDashboard,
    given_name,
    fileUploadActive,
    additional_dashboards,
    getUpdatedUser,
    createChatSession,
    chatsLeft,
    setMessageList,
    aiAssistant
  } = useAuth()
  const { subscription, plan } = useSubscription()
  const { width } = useWindowDimensions()
  const {
    selectedItem,
    isVisible,
    isExpanded,
    isFullScreen,
    toggleDrawer,
    toggleDrawerExpansion,
    setSelectedRoute,
    toggleDrawerOnHelpCenterExpansion
  } = useMenu()
  const [isEmailVerified, setEmailVerified] = useState(false)
  const [costumerFeedbackState, setCostumerFeedbackState] = useState({
    show: false,
    isModalOpen: false
  })
  const [userData, setUserData] = useState({})
  const [steps, setSteps] = useState({
    current: 0,
    elements: [ConfirmSignupModal],
    isVisible: false,
  })

  const getUser = async () => {
    try {
      const { attributes } = await Auth.currentUserInfo()
      let newUserData = { ...attributes }
      setUserData(newUserData)
    } catch (error) {
      console.log(error)
    }
  }

  // const profitWell = window?.profitwell('user_id', subscription_id )

  useEffect(() => {
    getUser()
    // profitWell
  }, [])


  const onCloseCostumerFeedback = () => {
    setCostumerFeedbackState((prev) => (
      {
        ...prev,
        show: false
      }
    ))
  }
  const onOpenCostumerFeedbackModal = () => {
    setCostumerFeedbackState((prev) => (
      {
        ...prev,
        isModalOpen: true
      }
    ))
  }
  const onCloseCostumerFeedbackModal = () => {
    setCostumerFeedbackState((prev) => (
      {
        show: false,
        isModalOpen: false
      }
    ))
  }

  const current = window.location.pathname
  const getGreetingTime = (currentTime) => {
    if (!currentTime || !currentTime.isValid()) {
      return 'Hello'
    }
    const splitAfternoon = 12
    const splitEvening = 17
    const currentHour = parseFloat(currentTime.format('HH'))

    if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
      return 'Good afternoon'
    } else if (currentHour >= splitEvening) {
      return 'Good evening'
    }
    return 'Good morning'
  }

  useEffect(() => {
    // when user has given a api key but he hasnt yet completed the middle name
    // if (!website_locked) { /* && !userAttributes?.hasOwnProperty('middle_name') */
    //   setSteps(prev => ({
    //     current: 1,
    //     elements: [...prev?.elements],
    //     isVisible: true
    //   }))
    // }
    if (website_locked) {
      setSteps(prev => ({
        current: 0,
        elements: [...prev?.elements],
        isVisible: true
      }))
    }
  }, [website_locked, userAttributes?.hasOwnProperty('middle_name')])

  useEffect(() => {
    if (localStorage.getItem('feedback')) {
      let date = localStorage.getItem('feedback')
      let start = moment(date)
      let end = moment().format('YYYY-MM-DD')
      // Difference in number of days
      let days = moment.duration(start.diff(end)).asDays()

      if (days <= -12) {
        setCostumerFeedbackState((prev) => (
          {
            show: true,
            isModalOpen: false
          }
        ))
        localStorage.setItem('feedback', JSON.stringify(moment().format('YYYY-MM-DD')))
      }
    } else {
      localStorage.setItem('feedback', JSON.stringify(moment().format('YYYY-MM-DD')))
      setCostumerFeedbackState((prev) => (
        {
          show: true,
          isModalOpen: false
        }
      ))
    }
  }, [])
  useEffect(() => {
    setSelectedRoute(current)
  }, [current])

  useEffect(() => {
    if (userAttributes?.email_verified) {
      setEmailVerified(true)
    } else {
      setEmailVerified(false)
    }

  }, [userAttributes])

  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
    let d = document
    let s = d.createElement('script')
    s.type = 'text/javascript'
    s.id = 'zsiqscript'
    s.defer = true
    s.src = 'https://salesiq.zoho.eu/widget'
    let t = d.getElementById('zohoChat')
    t.parentNode.insertBefore(s, t)
  }

  const greeting = getGreetingTime(moment())

  const handleOpenAdditional = () => {
    setOpen(!open)
    toggleDrawerOnHelpCenterExpansion()
  }

  const noAdditionalDashboards = additional_dashboards?.length === 0

  const newCHat = () => {
    if (chatsLeft === 0) {
      setMessageList([])
      toggleDrawer()
    }
    else {
      toggleDrawer()
    }
  }

  return (
    <Switch>
      <Route
        path={[
          '/dashboard',
          '/dashboard/:dashboard_id',
          '/xero',
          '/tooltips',
          '/settings',
          '/settings/account',
          '/settings/delete-account',
          '/settings/change-password',
          '/settings/terms&conditions',
          '/settings/targets',
          '/settings/payment-information',
          // '/enter-data',
          '/settings/report',
          '/settings/unsubscribe/:productId',
          '/store',
          '/ai-assistant'

        ]}
      >
        <div className={classes.root}>
          <div className={isFullScreen ? 'drawerWrapper' : ''}>
            <Hidden xsDown>
              <IconButton
                style={{ position: 'fixed' }}
                disableFocusRipple
                centerRipple={true}
                onClick={toggleDrawerExpansion}
                className={clsx(classes.drawer, {
                  [classes.drawerOpen]: isExpanded,
                  [classes.drawerClose]: !isExpanded,
                })}
              >
                {isExpanded ? (
                  <ArrowLeftIcon fill="#ee4352" className="toggleDrawerIcon" />
                ) : (
                  <ArrowRightIcon fill="#ee4352" className="toggleDrawerIcon" />
                )}
              </IconButton>
            </Hidden>
            <Drawer
              onOpen={toggleDrawer}
              onClose={toggleDrawer}
              variant={width > 760 ? 'permanent' : 'temporary'}
              isExpanded={isExpanded}
              isVisible={isVisible}
            >

              <Hidden smUp>
                <div className="logoContainer">


                  <div style={{ display: 'flex' }}>
                    <img src={logoIcon} className="logoIcon" onClick={() => {
                      history.push('/dashboard')
                      toggleDrawer()
                    }} />
                    {(isExpanded || width <= 760) && (
                      <img
                        src={logoName}
                        className="logoName"
                        onClick={() => {
                          history.push('/dashboard')
                          toggleDrawer()
                        }}
                      />
                    )}
                  </div>
                  <IconButton
                    disableFocusRipple
                    centerRipple={true}
                    classes={{ root: classes.iconButton }}
                    onClick={toggleDrawer}
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                </div>
              </Hidden>
              <div className="drawerContent">
                <div>
                  <Divider className="divider" variant="middle" />
                  <List>
                    {noAdditionalDashboards && dashboardItem.map((item, index) => (
                      <DrawerListItem
                        index={index}
                        key={index}
                        {...item}
                        isActive={selectedItem === item.to}
                        withTitle={isExpanded || width <= 760}
                        onClick={toggleDrawer}
                        component={item.component}
                        to={item.to}
                      />
                    ))}

                    {!noAdditionalDashboards &&
                      <DrawerNestedListItemDashboards
                        index={14}
                        key={14}
                        title="Dashboards"
                        Icon={DashboardIcon}
                        isActive={open}
                        withTitle={isExpanded || width <= 760}
                        onClick={() =>
                          handleOpenAdditional()
                        }
                        open={open}
                      //  items={additional_dashboards}
                      />
                    }

                    {xeroDashboard && xeroDashboardItems.map((item, index) => (
                      <DrawerListItem
                        index={index}
                        key={index}
                        {...item}
                        isActive={selectedItem === item.to}
                        withTitle={isExpanded || width <= 760}
                        onClick={toggleDrawer}
                        component={item.component}
                        to={item.to}
                      />
                    ))}
                    {DRAWER_ITEMS.map((item, index) => (
                      <DrawerListItem
                        index={index}
                        key={index}
                        {...item}
                        isActive={selectedItem === item.to}
                        withTitle={isExpanded || width <= 760}
                        onClick={toggleDrawer}
                        component={item.component}
                        to={item.to}
                      />
                    ))}
                    {fileUploadActive && DRAWER_UPLOAD_FILE.map((item, index) => (
                      <DrawerListItem
                        index={index}
                        key={index}
                        {...item}
                        isActive={selectedItem === item.to}
                        withTitle={isExpanded || width <= 760}
                        onClick={toggleDrawer}
                        component={item.component}
                        to={item.to}
                      />
                    ))}
                    {given_name === 'Halaxy' && DRAWER_FILES.map((item, index) => (
                      <DrawerListItem
                        index={index}
                        key={index}
                        {...item}
                        isActive={selectedItem === item.to}
                        withTitle={isExpanded || width <= 760}
                        onClick={toggleDrawer}
                        component={item.component}
                        to={item.to}
                      />
                    ))}
                    {given_name !== 'Halaxy' && DRAWER_OTHER_ITEMS.map((item, index) => (
                      <DrawerListItem
                        index={index}
                        key={index}
                        {...item}
                        isActive={selectedItem === item.to}
                        withTitle={isExpanded || width <= 760}
                        onClick={toggleDrawer}
                        component={item.component}
                        to={item.to}
                      />
                    ))}
                    {DRAWER_OTHER_ITEMS2.map((item, index) => (
                      <DrawerListItem
                        index={index}
                        key={index}
                        {...item}
                        isActive={selectedItem === item.to}
                        withTitle={isExpanded || width <= 760}
                        onClick={toggleDrawer}
                        component={item.component}
                        to={item.to}
                      />
                    ))}
                    <DrawerNestedListItem
                      index={4}
                      key={4}
                      title="Help Centre"
                      Icon={HelpIcon}
                      // isActive={open}
                      withTitle={isExpanded || width <= 760}
                      onClick={() =>
                        window.open(
                          'https://dataplayer.zohodesk.eu/portal/en-gb/signin',
                          '_blank'
                        )
                      }
                    // open={open}
                    />
                    {isMobile && DRAWER_ITEMS_MOBILE.map((item, index) => (
                      <DrawerListItem
                        index={index}
                        key={index}
                        {...item}
                        isActive={selectedItem === item.to}
                        withTitle={isExpanded || width <= 760}
                        onClick={toggleDrawer}
                        component={item.component}
                        to={item.to}

                      />
                    ))}
                    <DrawerNestedListItem
                      index={5}
                      key={5}
                      title="Chat with us"
                      Icon={() => <ChatBubbleIcon style={{ width: 22, height: 22, marginLeft: 18, backgroundColor: 'transparent', color: colors.accent }} />}
                      isActive={open}
                      withTitle={isExpanded || width <= 760}
                      onClick={() => handleClick()}
                    // open={open}
                    />
                    {aiAssistant && aiAssistantItem.map((item, index) => (
                      <DrawerListItem
                        index={index}
                        key={index}
                        {...item}
                        isActive={selectedItem === item.to}
                        withTitle={isExpanded || width <= 760}
                        onClick={newCHat}
                        component={item.component}
                        to={item.to}
                      />
                    ))}


                  </List>
                </div>
                <div>
                  {(plan?.[0]?.name === 'Mega' || plan?.[0]?.name === 'Giga') && <ReferalCard isExpanded={isExpanded} isMobile={isMobile} onClick={toggleDrawer} />}
                  {!isEmailVerified && isExpanded && current !== '/settings/account' && <VerifyEmailCardDrawer onClose={() => setEmailVerified(true)} />}
                  {is_trialing && <TrialDaysCard isExpanded={isExpanded} end_of_trial_date={end_of_trial_date} />}
                  {isMobile &&
                    <div className={classes.buttonDiv}>
                      <PrimaryButton
                        onClick={() => history.push('/upgradeplan')}
                        className={classes.button}>
                        Upgrade now
                      </PrimaryButton>
                    </div>
                  }

                  <Divider style={{ marginInline: '25px !important' }} className="divider2" variant="middle" />

                  <DrawerListItem
                    index={9999}
                    title="Log out"
                    Icon={LogoutIcon}
                    isActive={true}
                    withTitle={isExpanded || width <= 760}
                    onClick={logout}
                  />
                </div>
              </div>
            </Drawer>
          </div>
          <main className={classes.content}>
            <div className="homeContent">
              <Route exact path="/dashboard" component={Dashboard} />
              {additional_dashboards?.length > 0 && <Route exact path="/dashboard/:dashboard_id" component={MultipleDashboard} />}
              <Route exact path="/xero" component={XERODashboard} />
              {/* <Route exact path="/enter-data" component={ManuallyAddData} /> */}
              <Route exact path="/tooltips" component={Tooltips} />
              <Route exact path="/store" component={Store} />
              <Route exact path="/ai-assistant" component={aiAssistant && AIAssistant} />
              <Route
                exact
                path={[
                  '/settings',
                  '/settings/account',
                  '/settings/myFiles',
                  '/settings/uploadFile',
                  '/settings/delete-account',
                  '/settings/change-password',
                  '/settings/terms&conditions',
                  '/settings/targets',
                  '/settings/payment-information',
                  '/settings/report',
                  '/settings/unsubscribe/:productId'
                ]}
                component={Settings}
              />
            </div>
            {costumerFeedbackState.show
              &&
              <CostumerFeedbackInput
                onClose={onCloseCostumerFeedback}
                onOpenCostumerFeedbackModal={onOpenCostumerFeedbackModal}
              />
            }
          </main>
          <BillNotPaidModal
            isVisible={subscription?.state === 'paused'}
            type={plan?.[0]?.billing_type === 'month' ? 'monthly' : plan?.[0]?.billing_type === 'year' ? 'yearly ' : ''}
            plan={plan?.[0]?.name || ''}
            updatePayment={() => window.open(subscription?.update_url, '_blank')}
          />
          <StepperModal
            isVisible={steps.isVisible}
            current={steps.current}
            elements={steps.elements}
            onSuccessAPI={() => {
              setSteps(prev => ({
                ...prev,
                isVisible: false
                // current: prev.current + 1,
              }))
            }}
          />
          <GigaAccountEndedModal
            isVisible={showFreeTrialModal === true && active_dash === true}
          />
          <InactiveToActiveModal isVisible={account_state === 'inactive' && active_dash === false && plan?.length === 0} />
          <CostumerModalFeedback
            isVisible={costumerFeedbackState.isModalOpen}
            cancel={onCloseCostumerFeedbackModal}
          />
        </div>
      </Route>
      <Route exact path="/storedetails/:productId" component={StoreProductDetails} />
      <Route exact path="/upgradeplan" component={UpgradePlan} />
      <Route exact path="/upgrade" component={UpgradeSubscription} />
      <Route exact path="/cancelPlan" component={DeletePlan} />
      <Redirect to="/dashboard" path={['/', '/reset-password', '/login']} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default withRouter(MiniDrawer)
